// SalesPage.js
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useHomeStore from "../components/ZustandStore/useHomeStore";
import Card from "../Card";
import { BASE_URL } from "..";
import { SHOP_GET_API } from "../app/constants";
import { useForm } from "react-hook-form";
import axios from "axios";

const SalesPage = () => {
  const { categorySlug } = useParams();

  const {
    selectedCategoryData,
    fetchCategoryData,
    deals,
    fetchDeals,
    setTotalPages,
    pageSize,
    totalResults,
    setTotalResults,
    currentPage,
    totalPages,
    setCurrentPage,
  } = useHomeStore();

  const [active, setActive] = useState(false);
  const sidebarController = () => {
    setActive(!active);
  };

  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [products, setProducts] = useState([]);
  const [grid, setGrid] = useState(true); // Grid or List view
  const [sortedProducts, setSortedProducts] = useState([]);

  // Pagination rendering

  const renderPagination = () => {
    const pages = [];
    const startPage = Math.max(0, currentPage - 4);
    const endPage = Math.min(totalPages - 1, startPage + 9);

    pages.push(
      <li
        key="first"
        className={`page-item ${currentPage === 0 ? "disabled" : ""}`}
      >
        <Link className="page-link" to="#" onClick={() => setCurrentPage(0)}>
          First
        </Link>
      </li>
    );

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${i === currentPage ? "active" : ""}`}
        >
          <Link className="page-link" to="#" onClick={() => setCurrentPage(i)}>
            {String(i + 1).padStart(2, "0")}
          </Link>
        </li>
      );
    }

    pages.push(
      <li
        key="last"
        className={`page-item ${
          currentPage === totalPages - 1 ? "disabled" : ""
        }`}
      >
        <Link
          className="page-link"
          to="#"
          onClick={() => setCurrentPage(totalPages - 1)}
        >
          Last
        </Link>
      </li>
    );

    return pages;
  };

  const getPaginationRange = () => {
    const start = currentPage * pageSize + 1;
    const end = Math.min((currentPage + 1) * pageSize, totalResults);
    return `${start}-${end}`;
  };

  const { register, handleSubmit, watch } = useForm();
  const handleSortChange = (e) => {
    const selectedOption = e.target.value; // Get selected sorting option
    const params = new URLSearchParams();

    params.append("page", currentPage);
    if (selectedOption === "Latest") {
      params.append("sortBy", "Latest");
    } else if (selectedOption === "relevent") {
      params.append("sortBy", "relevent");
    } else if (selectedOption === "popular") {
      params.append("sortBy", "popularity");
    } else if (selectedOption === "price-asc") {
      params.append("sortBy", "priceLowToHigh");
    } else if (selectedOption === "price-desc") {
      params.append("sortBy", "priceHighToLow");
    }

    if (minPrice) params.append("minPrice", minPrice);
    if (maxPrice) params.append("maxPrice", maxPrice);

    axios
      .get(`${BASE_URL}${SHOP_GET_API}?${params.toString()}`)
      .then((response) => {
        setProducts(response.data.data.content); // Set products based on response
        setTotalPages(response.data.data.totalPages);
        setTotalResults(response.data.data.totalElements);
      })
      .catch((error) => {
        console.error("Error fetching filtered products:", error);
      });
  };

  const handleFilter = (data) => {
    // Prepare params for filters
    const params = new URLSearchParams();

    // Apply price filters
    if (data.minPrice) params.append("minPrice", data.minPrice);
    if (data.maxPrice) params.append("maxPrice", data.maxPrice);

    // Fetch filtered data from API
    axios
      .get(`${BASE_URL}${SHOP_GET_API}?${params.toString()}`)
      .then((response) => {
        setProducts(response.data.data.content);
        setTotalPages(response.data.data.totalPages);
        setTotalResults(response.data.data.totalElements);
      })
      .catch((error) => {
        console.error("Error fetching filtered products:", error);
      });
  };

  // Reset page when categorySlug changes
  useEffect(() => {
    if (categorySlug) {
      setCurrentPage(0);
      setTotalPages(0);
    }
  }, [categorySlug]);

  // Fetch data when categorySlug or currentPage changes
  useEffect(() => {
    const fetchData = async () => {
      if (categorySlug) {
        if (categorySlug === "daily-deals") {
          await fetchDeals();
        } else {
          await fetchCategoryData(categorySlug);
        }
      }
    };

    fetchData();
  }, [categorySlug, currentPage]); // Depend on categorySlug and currentPage only

  return (
    <section className="sales">
      <div className={`side-overlay ${active && "show"}`}></div>
      <div className="container container-lg">
        <div className="row">
          <div className="section-heading flex-between">
            <div className="flex-between flex-wrap gap-8">
              <h2 className="mb-0 text-xl text-capitalize">
                {categorySlug.replace(/-/g, " ")}
              </h2>
            </div>
            <div className="flex-between ga flex-wrap ">
              <span className="text-gray-900"></span>
              <div className="position-relative flex-align ga flex-wrap">
                {/* <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                  <label
                    htmlFor="sorting"
                    className="text-inherit flex-shrink-0"
                  >
                    Sort by:
                  </label>
                  <select
                    defaultValue={1}
                    className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                    id="sorting"
                    onChange={handleSortChange}
                  >
                    <option value="latest">Latest</option>
                    <option value="relevent">Relevent</option>
                    <option value="popular">Popular</option>
                    <option value="price-asc">Price Low to High</option>
                    <option value="price-desc">Price High to Low</option>
                  </select>
                </div> */}
              </div>
            </div>
          </div>

          {/* Content Start */}

          <div className="col-lg-9 w-100">
            {/* Top Start */}
            <section className="shop-products w-100">
              {/* Upper Section */}
              <div className="container container-lg">
                {/* Section Header */}

                {/* Product Grid or List */}
                {grid ? (
                  <div
                    className="product-grid"
                    style={{
                      display: "grid",
                      alignItems: "center",
                      justifyContent: "center",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(240px, 1fr))",
                      gap: "26px",
                    }}
                  >
                    {selectedCategoryData.length > 0 ? (
                      selectedCategoryData.map((product) => (
                        <Card
                          key={product.id}
                          imageSrc={product.image}
                          title={product.title}
                          badge={product.badge}
                          offered={product.selling}
                          purchased={product.offered}
                          productLink={`/product/${product.slug}`}
                          cartID={product.id}
                          freeDelivery={product.freeDelivery}
                          product={product}
                        />
                      ))
                    ) : (
                      <div className="text-center py-4">
                        No products available for this category.
                      </div>
                    )}
                  </div>
                ) : (
                  <table className="table bg-color-three border-top-0 border-right-0 border-left-0">
                    <tbody>
                      {sortedProducts.map((item) => (
                        <tr key={item.productId}>
                          <td className="align-middle text-center">
                            <div className="table-product d-flex align-items-center gap-24">
                              <Link
                                to={`/product/${item.slug}`}
                                className="table-product__thumb rounded-8 flex-center"
                                aria-label={`View details of ${item.title}`}
                              >
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  className="img-fluid"
                                />
                              </Link>
                            </div>
                          </td>
                          <td className="align-middle text-center">
                            <div className="table-product__content text-start">
                              <h6
                                className="title text-lg fw-semibold mb-8"
                                style={{ minWidth: "3rem" }}
                              >
                                <Link
                                  to={`/product/${item.slug}`}
                                  className="link text-line-2"
                                  tabIndex={0}
                                  aria-label={`View details of ${item.title}`}
                                >
                                  {item.title}
                                </Link>
                              </h6>
                              {item.description && (
                                <h6 className="title text-sm fw-semibold mb-8 text-muted d-none d-md-block">
                                  {item.description}
                                </h6>
                              )}
                            </div>
                          </td>
                          <td
                            className="align-middle"
                            style={{ minWidth: "5rem" }}
                          >
                            <span className="text-lg text-main h6 mb-0 text-nowrap ">
                              Rs. {item.offered}
                            </span>

                            {item.offered && (
                              <div className="text-decoration-line-through text-sm mb-0 fw-semibold text-muted">
                                Rs. {item.selling}
                              </div>
                            )}

                            <div className="d-flex gap-16 mt-2">
                              <i className="bi bi-trash text-muted cursor-pointer text-lg"></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>

              {/* Pagination */}
              <div className="flex-center">
                <div aria-label="Page navigation example">
                  <div className="pagination flex-wrap">
                    {renderPagination()}
                    <div
                      className="page-item"
                      style={{
                        color: "black",
                        textDecoration: "none",
                      }}
                    >
                      <div className="page-link" style={{ color: "black" }}>
                        {`Page ${currentPage + 1} of ${totalPages}`}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Main Content */}
            </section>
            {/* Top End */}
          </div>
          {/* Content End */}
        </div>
      </div>
    </section>
  );
};

export default SalesPage;
